<script setup>
import {computed, onMounted, ref} from 'vue'
import {useViewStore} from '@/stores/view'

const props = defineProps({
    viewId: String
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Template refs
const input = ref(null)

// Computed properties
const searchTerm = computed({
    get() {
        return viewStore.searchTerm
    },
    set(val) {
        viewStore.searchTermAction(val)
    }
})

const active = computed(() => {
    return searchTerm.value !== ''
})

// Lifecycle Hooks
onMounted(() => {
    input.value?.focus()
})
</script>

<template>
    <span class="d-flex align-items-center position-relative">
        <i class="bi bi-search"/>
        <input ref="input" v-model="searchTerm" class="form-control form-control-sm rounded-5 p-0 pe-2"
               :class="{'active': active}">
    </span>
</template>

<style scoped>
input {
    transition: all 0.2s;
    padding-left: 30px !important;
    max-width: 120px;
}

/* This causes issues with clicking on items to the right of the search field
input:focus,
input.active {
    max-width: 150px;
}*/

i {
    position: absolute;
    left: 7px;
    color: #999;
}
</style>